var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "rewardSetting"
    }
  }, [_c("a-form-model", {
    ref: "rewardData",
    staticStyle: {
      padding: "24px 24px 0",
      "border-bottom": "24px solid #f0f2f5"
    },
    attrs: {
      model: _vm.rewardData,
      rules: _vm.rules
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "productPointRate"
    }
  }, [_c("span", {
    attrs: {
      slot: "label"
    },
    slot: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("basicSettings.rewardGiftRatio")) + "  "), _c("a-tooltip", {
    attrs: {
      title: _vm.$t("basicSettings.rewardGiftRatioPrompt")
    }
  }, [_c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1)], 1), _c("a-input-number", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      min: 0,
      max: 100
    },
    model: {
      value: _vm.rewardData.productPointRate,
      callback: function callback($$v) {
        _vm.$set(_vm.rewardData, "productPointRate", $$v);
      },
      expression: "rewardData.productPointRate"
    }
  })], 1), _c("a-form-model-item", {
    ref: "onePointMoney",
    attrs: {
      prop: "onePointMoney",
      label: _vm.$t("basicSettings.oneRewardConversion")
    }
  }, [_vm._v(" " + _vm._s(_vm.systemSetting.leftCurrencySymbol) + " "), _c("a-input-number", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      min: 0,
      max: 99999
    },
    on: {
      blur: function blur() {
        _vm.$refs.onePointMoney.onFieldBlur();
      }
    },
    model: {
      value: _vm.rewardData.onePointMoney,
      callback: function callback($$v) {
        _vm.$set(_vm.rewardData, "onePointMoney", $$v);
      },
      expression: "rewardData.onePointMoney"
    }
  }), _vm._v(" " + _vm._s(_vm.systemSetting.rightCurrencySymbol) + " ")], 1), _c("a-form-model-item", {
    ref: "rewardValidity",
    attrs: {
      prop: "rewardValidity",
      label: _vm.$t("basicSettings.rewardValidity")
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "200px"
    },
    attrs: {
      min: 1,
      max: 99999,
      precision: 0
    },
    on: {
      blur: function blur() {
        _vm.$refs.rewardValidity.onFieldBlur();
      }
    },
    model: {
      value: _vm.rewardData.rewardValidity,
      callback: function callback($$v) {
        _vm.$set(_vm.rewardData, "rewardValidity", $$v);
      },
      expression: "rewardData.rewardValidity"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("basicSettings.rewardValidityUnit1")) + " ")], 1), _c("a-form-model-item", [_c("a-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingSave
    },
    on: {
      click: _vm.saveReward
    }
  }, [_vm._v(_vm._s(_vm.$t("publicuse.save")))])], 1)], 1), _c("a-card", {
    staticClass: "card",
    attrs: {
      title: _vm.$t("basicSettings.evaluatePresentIntegralList"),
      bordered: false
    }
  }, [_c("a-table", {
    attrs: {
      pagination: false,
      rowKey: "id",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.evaluatePointList
    },
    scopedSlots: _vm._u([{
      key: "productMoney",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.systemSettingData.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(record.startMoney)) + _vm._s(_vm.systemSettingData.rightCurrencySymbol) + " ~ " + _vm._s(_vm.systemSettingData.leftCurrencySymbol) + _vm._s(_vm._f("toThousandslsFilter")(record.endMoney)) + _vm._s(_vm.systemSettingData.rightCurrencySymbol) + " ")]);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };